module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "container",
    attrs: {
      "id": "summary"
    }
  }, [_c('div', {
    staticClass: "segment box"
  }, [_c('h1', {
    staticClass: "title is-uppercase has-text-centered"
  }, [_vm._v("Gamesheet")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Cardiff Devils")]), _vm._v(" "), _c('div', {
    staticClass: "small-box"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Forwards")]), _vm._v(" "), _c('sort-table', {
    attrs: {
      "endpoint": "https://devilsapi.roblutken.com/api/app/gamesheet",
      "postData": [{
        team_id: 1,
        game_id: this.gameId,
        position: 'forward'
      }],
      "selectedData": [{
          title: 'player',
          prop: 'player'
        },
        {
          title: 'G +/-',
          prop: 'goal_diff'
        },
        {
          title: 'Shots +/-',
          prop: 'shots_diff'
        },
        {
          title: 'SOT',
          prop: 'shots_on_net'
        },
        {
          title: 'FO',
          prop: 'faceoffs'
        },
        {
          title: 'Shifts',
          prop: 'toi_shifts'
        },
        {
          title: 'AVG Shift',
          prop: 'toi_avg_shifts'
        },
        {
          title: 'P1',
          prop: 'toi_p1'
        },
        {
          title: 'P2',
          prop: 'toi_p2'
        },
        {
          title: 'P3',
          prop: 'toi_p3'
        },
        {
          title: 'EH',
          prop: 'toi_eh'
        },
        {
          title: 'PP',
          prop: 'toi_pp'
        },
        {
          title: 'SH',
          prop: 'toi_sh'
        },
        {
          title: 'Total TOI',
          prop: 'toi_total'
        }
      ]
    },
    on: {
      "dataLoaded": _vm.gameDataLoaded
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Defense")]), _vm._v(" "), _c('sort-table', {
    attrs: {
      "endpoint": "https://devilsapi.roblutken.com/api/app/gamesheet",
      "postData": [{
        team_id: 1,
        game_id: this.gameId,
        position: 'defense'
      }],
      "selectedData": [{
          title: 'player',
          prop: 'player'
        },
        {
          title: 'G +/-',
          prop: 'goal_diff'
        },
        {
          title: 'Shots +/-',
          prop: 'shots_diff'
        },
        {
          title: 'SOT',
          prop: 'shots_on_net'
        },
        {
          title: 'FO',
          prop: 'faceoffs'
        },
        {
          title: 'Shifts',
          prop: 'toi_shifts'
        },
        {
          title: 'AVG Shift',
          prop: 'toi_avg_shifts'
        },
        {
          title: 'P1',
          prop: 'toi_p1'
        },
        {
          title: 'P2',
          prop: 'toi_p2'
        },
        {
          title: 'P3',
          prop: 'toi_p3'
        },
        {
          title: 'EH',
          prop: 'toi_eh'
        },
        {
          title: 'PP',
          prop: 'toi_pp'
        },
        {
          title: 'SH',
          prop: 'toi_sh'
        },
        {
          title: 'Total TOI',
          prop: 'toi_total'
        }
      ]
    },
    on: {
      "dataLoaded": _vm.gameDataLoaded
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Goaltending")]), _vm._v(" "), _c('sort-table', {
    attrs: {
      "endpoint": "https://devilsapi.roblutken.com/api/app/gamesheet",
      "postData": [{
        team_id: 1,
        game_id: this.gameId,
        position: 'goaltender'
      }],
      "selectedData": [{
          title: 'player',
          prop: 'player'
        },
        {
          title: 'G +/-',
          prop: 'goal_diff'
        },
        {
          title: 'Shots +/-',
          prop: 'shots_diff'
        },
        {
          title: 'SOT',
          prop: 'shots_on_net'
        },
        {
          title: 'FO',
          prop: 'faceoffs'
        },
        {
          title: 'Shifts',
          prop: 'toi_shifts'
        },
        {
          title: 'AVG Shift',
          prop: 'toi_avg_shifts'
        },
        {
          title: 'P1',
          prop: 'toi_p1'
        },
        {
          title: 'P2',
          prop: 'toi_p2'
        },
        {
          title: 'P3',
          prop: 'toi_p3'
        },
        {
          title: 'EH',
          prop: 'toi_eh'
        },
        {
          title: 'PP',
          prop: 'toi_pp'
        },
        {
          title: 'SH',
          prop: 'toi_sh'
        },
        {
          title: 'Total TOI',
          prop: 'toi_total'
        }
      ]
    },
    on: {
      "dataLoaded": _vm.gameDataLoaded
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-536df366"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/stats/gamesheet.vue
// module id = 621
// module chunks = 30